import { render, staticRenderFns } from "./AModEstudiante.vue?vue&type=template&id=243a245c"
import script from "@/components/estudiante-mod.js?vue&type=script&lang=js&external"
export * from "@/components/estudiante-mod.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports